import { membersApi } from "@/api/members.api";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { storeToRefs } from "pinia";
import { queryClient } from "./queryClient";

export function useMembersDetails() {
  const appStore = storeToRefs(useAppStore());
  return useQuery({
    queryKey: ['members', { organisationId: appStore.currentOrganisationId }, 'details'],
    queryFn: async () => { 
      const membersDetails = await membersApi.getMembersDetails(toValue(appStore.currentOrganisationId));
      for (const details of membersDetails) {
        queryClient.setQueryData(['members', { organisationId: appStore.currentOrganisationId, memberId: details.member.id }, 'details'], details);
      }
      return membersDetails;
    },
    enabled: !!toValue(appStore.currentOrganisationId)
  });
}

export function useDeleteMember() {
  return useMutation({
    mutationFn: (data: { organisationId: string, memberId: string }) => membersApi.deleteMember(data.organisationId, data.memberId),
    onSuccess: (_, variables) => {
      queryClient.setQueryData(['members', { organisationId: variables.organisationId, memberId: variables.memberId }, 'details'], undefined);
      queryClient.setQueryData(['members', { organisationId: variables.organisationId, memberId: variables.memberId }, 'roles'], undefined);
      queryClient.invalidateQueries({ queryKey: ['members', { organisationId: variables.organisationId }] });
    }
  });
}

export function useUpdateMemberRole() {
  const appStore = storeToRefs(useAppStore());
  return useMutation({
    mutationFn: (data: { memberId: string, roleId: string }) => membersApi.updateMemberRole(data.memberId, data.roleId),
    onSuccess: (_, data) => {
      queryClient.invalidateQueries({ queryKey: ['members', { organisationId: appStore.currentOrganisationId, memberId: data.memberId }, 'roles'] });
    },
  })
}